module.exports = __webpack_public_path__ + "static/media/v17.3e304ce5.mp4";